import './form.scss';
import { Box, Container, Grid, Link } from '@mui/material';


function FormUpload() {
    return (
        <>
            <Box className="lockerBanner" >
                <Container maxWidth="md">
                    <Grid container spacing={2} justifyContent="left" alignItems="center">
                        <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} >
                            <Box className="bannerText text-center">
                                <h1>Upload Your VR Reel</h1>
                                <span>One story. One world. One shot at India's next great mythology reel. Fill in the details, drop your file, and hit submit.</span>
                            </Box>
                        </Grid>
                    </Grid>
                </Container>
            </Box>
            <section className="upload-section">
                <Container maxWidth="md">
                    <Grid container spacing={3} justifyContent="left">
                        <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} >
                            <div className="reelForm">

                                {/* Section 01 */}
                                <div className="formSection">
                                    <div className="sectionHeader">
                                        <span className="step">01</span>
                                        <h3>Your Reel</h3>
                                    </div>

                                    <div className="uploadArea">
                                        <input type="file" hidden id="videoUpload" />

                                        <label htmlFor="videoUpload">
                                            <div className="iconBox">
                                                <i className="fa fa-cloud-upload"></i>
                                            </div>

                                            <h4>
                                                Drag & drop your video, or <span>Browse</span>
                                            </h4>

                                            <p>
                                                MP4, MOV, WEBM · Max 500MB · 60–180 seconds recommended
                                            </p>
                                        </label>
                                    </div>
                                </div>

                                {/* Section 02 */}
                                <div className="formSection">
                                    <div className="sectionHeader">
                                        <span className="step">02</span>
                                        <h3>Reel Details</h3>
                                    </div>

                                    <div className="sectionBody">

                                        <div className="mb-4">
                                            <label>REEL TITLE</label>
                                            <input type="text" className="form-control customInput" />
                                        </div>

                                        <div className="mb-4">
                                            <label>CATEGORY</label>
                                            <select className="form-select customInput">
                                                <option>Select Category</option>
                                            </select>
                                        </div>

                                        <div>
                                            <label>SHORT DESCRIPTION</label>
                                            <textarea
                                                rows="6"
                                                className="form-control customInput textarea"
                                            ></textarea>
                                        </div>

                                    </div>
                                </div>

                                {/* Section 03 */}
                                <div className="formSection">
                                    <div className="sectionHeader">
                                        <span className="step">03</span>
                                        <h3>About You</h3>
                                    </div>

                                    <div className="sectionBody">
                                        <div className="row">

                                            <div className="col-lg-6 mb-3">
                                                <label>FULL NAME</label>
                                                <input
                                                    type="text"
                                                    className="form-control customInput"
                                                />
                                            </div>

                                            <div className="col-lg-6 mb-3">
                                                <label>EMAIL</label>
                                                <input
                                                    type="email"
                                                    className="form-control customInput"
                                                />
                                            </div>

                                        </div>
                                    </div>
                                </div>

                                {/* Agreement */}
                                <div className="agreementBox">

                                    <div className="form-check">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            id="agree"
                                        />

                                        <label
                                            className="form-check-label"
                                            htmlFor="agree"
                                        >
                                            I confirm this reel is my original work and I agree to the
                                            <span> competition rules </span>
                                            and content guidelines.
                                        </label>
                                    </div>

                                </div>

                                {/* Submit */}
                                <div className="submitBox">
                                    <button className="btn submitBtn">
                                        Submit Your Reel
                                    </button>

                                    <p>
                                        You'll receive a confirmation email once your submission is queued for review.
                                    </p>
                                </div>

                            </div>
                        </Grid>
                    </Grid>

                </Container>
            </section>



        </>
    );
}
export default FormUpload;